module.exports = __webpack_public_path__ + "img/google-play.db9b21a1.png";